<template lang="pug">
  .rss-landing-top
    Row(align-items="stretch")
      Column(
        mobile="12"
        tablet="12"
        desktop="5"
      )
        .track-order-form
          h3 {{ __('Track Your Order') }}
          p.callout {{ __(callout) }}
          track-order-form.shipping-tracker-form(
            :force-button-enabled="true"
          )
      Column(
        mobile="12"
        tablet="12"
        desktop="7"
      )
        YouTubeVideo(
          v-if="$rogue.site.code !== 'AUS'"
          :placeholder="rssVideoPlaceholder"
          video-id="_UfFYjUcIaI"
          :player-icon="{ size: 'xxxxxxl' }"
        )
        figure(v-else)
          img(:src="rssVideoPlaceholder" alt="")
    .rss-notice-wrapper
      h2.rss-notice-title {{ __('How the Rogue Shipping System Works') }}
      Column.rss-notice-how-it-works.no-gutter(mobile="12" tablet="9" desktop="9").
        {{ __(howRSSWorks[$rogue.site.code] || howRSSWorks.default) }}
      img.rss-tracker-img(:src="landingStatusBar" alt="Status Bar" )
      Column.rss-notice-fine-print(
        v-if="$rogue.site.code === 'USA'"
        mobile="12"
        tablet="12"
        desktop="11"
      )
        span.
          {{ __([
            '*Same Day Shipping applies to in-stock parcel orders (i.e. non-clearance or scratch-and-dent)',
            'placed on the US website',
          ].join(' ')) }} (
        a(target="_blank" href="https://www.roguefitness.com") 'https://www.roguefitness.com'
        span.
          ) {{ __([
            'before 3pm EST Monday through Friday; shipping only within the continental United States.',
            'If Rogue needs to contact you to validate or amend your order or payment information in order to',
            'collect payment, your shipment could be delayed. Same Day Shipping means your order is packaged',
            'and ready prior to the last scheduled pickup at Rogue’s shipping dock. Please note, Rogue cannot',
            'be responsible for delays due to weather, power outages, or any other acts of nature beyond',
            'our control. Excludes any orders placed during MBF sale period',
          ].join(' ')) }}
</template>

<script setup lang="ts">
import TrackOrderForm      from '../components/track-order-form.vue'
import landingStatusBar    from '../assets/landing-status-bar.jpg'
import rssVideoPlaceholder from '../assets/warehouse-move.jpg'

const callout = `Track your Rogue Order from the moment we receive it to the moment you get it. To track an order,
enter the order number and email used when your order was placed.`
const howRSSWorks = {
  USA: `The Rogue Shipping System is designed to get your new products to you as fast and efficiently as possible.
  Most in-stock parcel orders placed by 3PM ship the same business day. * Our online Shipping Tracker allows you
  to follow the progress of your order from our warehouse floor to the time it hits your door. Order today,
  track today.`,
  default: `The Rogue Shipping System is designed to get your new products to you as fast and efficiently as possible.
  Our online Shipping Tracker allows you to follow the progress of your order from our warehouse floor to the time
  it hits your door. Order today, track today.`,
}
</script>

<style lang="scss" scoped>
  .rss-landing-top {
    .track-order-form {
      padding : $space-l;
      border  : $space-s solid #f1f1f1;
      height  : 100%;
    }

    .callout {
      font-size : $size-xs;
      margin-bottom: $space-m;
    }
  }

  figure {
    margin: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  :deep() {
    .track-order {
      .field:last-of-type {
        margin-bottom: $space-m;
      }
    }

    .video-container, .placeholder-container {
      height   : 100%;
      overflow : hidden;
    }

    @media (max-width: $desktop) {
      .placeholder-container .placeholder {
        width: 100%;
      }
    }

    @media (min-width: $desktop) {
      .placeholder-container .placeholder {
        max-width : none;
        position  : absolute;
        top       : 50%;
        left      : 50%;
        transform : translate(-50%, -50%);
      }
    }

    .video-wrapper {
      padding-bottom : 0;
      height         : 100%;
    }

    .icon {
      height : $size-xxxxxxl;
      width  : $size-xxxxxxl;
    }
  }

  .rss-notice-wrapper {
    display        : flex;
    overflow       : hidden;
    flex-direction : column;
    align-items    : center;
    max-width      : $small-desktop;
    margin         : 0 auto;
    padding        : $space-l $space-l $space-xxs;
  }

  .rss-notice-title {
    margin-top : $space-l;
    text-align : center;
  }

  .rss-tracker-img {
    margin-bottom : $space-xl;
  }

  .rss-notice-how-it-works {
    font-size   : $size-s;
    line-height : $size-xl;
    margin      : 0 auto $space-l;
    text-align  : center;
  }

  .rss-notice-fine-print {
    font-size   : $size-xxs;
    line-height : 1.25;
    text-align  : center;
    margin      : 0 auto;
  }
</style>

<style lang="scss" scoped target="app">
  .platform-ios, .platform-android {
    .rss-landing-top {
      .track-order-form, .rss-notice-wrapper {
        padding: $app-gap-default;
      }

      .rss-notice-title {
        margin: $app-gap-default 0;
      }
    }
  }
</style>
